<template>
    <div>
        <div v-if="!searchSelected && $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smAndUp"
             :class="[{'navDrawer': $vuetify.breakpoint.smAndUp},
                          {'navDrawerMob': $vuetify.breakpoint.xsOnly}]">
            <selection-list :list="searchTypes" title="Suche nach"
                            @selected="selectSearch" hide-id="true">
            </selection-list>
        </div>
        <div :class="[{'content': $vuetify.breakpoint.smAndUp}, 'pa-4']">
            <div v-if="searchSelected">
                <div v-if="(searchSelected.id===3 || searchSelected.id===4)  && landesverbaende.length>1">
                    Bitte den Landesverband wählen:
                    <v-select  v-model="lvId"
                              :items="landesverbaende" item-text="name" item-value="id"
                              label="Landesverband" solo hide-details class="mt-2 mb-4"
                    ></v-select>
                </div>
                <div v-if="searchSelected.id===0">Bitte den gesuchten Nachnamen vollständig(!!!) eingeben:</div>
                <div v-else-if="searchSelected.id===2">
                    Bitte gibt Vor- oder Nachnamen ein (mindestens 3 Buchstaben):
                    <v-autocomplete class="mt-3 mb-1"
                            no-data-text="keine Daten gefunden"
                            v-model="model"
                            :items="items"
                            :search-input.sync="search"
                            :solo="$vuetify.breakpoint.smAndUp" flat
                            :dense="$vuetify.breakpoint.smAndUp"
                            hide-no-data
                            no-filter :filled="$vuetify.breakpoint.xsOnly"
                            :loading="loading"
                            item-text="Description"
                            label="Bitte mindestens 3 Zeichen eingeben!"
                            placeholder="Bitte mindestens 3 Zeichen eingeben!"
                            prepend-icon="mdi-magnify"
                            return-object
                    >
                        <template v-slot:append>
                            <v-progress-circular v-if="loading" indeterminate color="primary" size="26" width="3"></v-progress-circular>
                        </template>
                    </v-autocomplete>
                    <!-- item-value="API" hide-selected -->
                </div>
                <div v-else-if="searchSelected.id===1">
                    Bitte die gesuchte Passnummer eingeben (6-stellig):
                    <v-text-field v-model="searchDB" prepend-inner-icon="mdi-magnify"
                                  label="Passnummer" :solo="$vuetify.breakpoint.smAndUp" flat
                                  :dense="$vuetify.breakpoint.smAndUp" light class="mt-3 mb-5 white"
                                  single-line hide-details :filled="$vuetify.breakpoint.xsOnly"
                                  @keyup="keyPressed($event, 'pass')" type="number">
                        <template v-slot:append>
                            <v-btn icon small class="pb-1">
                                <v-icon style="cursor: pointer" @click="searchDB=''">mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </div>
                <div v-else-if="searchSelected.id===3">
                    Bitte das Passablaufjahr eingeben (4-stellig):
                    <v-text-field v-model="searchJahr" prepend-inner-icon="mdi-magnify"
                                  label="Jahr 4-stellig" :solo="$vuetify.breakpoint.smAndUp" flat
                                  :dense="$vuetify.breakpoint.smAndUp" light class="mt-2 mb-5 white"
                                  single-line hide-details :filled="$vuetify.breakpoint.xsOnly"
                                  @keyup="keyPressed($event, 'jahr')" type="number">
                        <template v-slot:append>
                            <v-btn icon small class="pb-1">
                                <v-icon style="cursor: pointer" @click="searchDB=''">mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </div>
                <v-btn v-if='searchSelected.id!==2' @click="startSearch()" class="mb-5" color="primary">
                    Suche starten</v-btn>
                <error-msg :error="errorMsg" class="font-weight-bold"></error-msg>
                <div v-if="bindsRealTimeList" class="text-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <search-spieler-abgelaufen v-else-if="searchSelected.id===3">
                </search-spieler-abgelaufen>
                <search-spieler-missing-docs v-else-if="searchSelected.id===4">
                </search-spieler-missing-docs>
                <search-spieler-result v-else :selected="searchSelected.id">
                </search-spieler-result>
            </div>
            <div v-else class="grey--text pa-5">
                Bitte wähle eine Suchmethode aus dem Menü auf der linken Seite!
                <img width="300" src="../../assets/oeskb.png" class="logo">
            </div>
        </div>
        <v-btn v-if="searchSelected && $vuetify.breakpoint.xsOnly" fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="searchSelected=null">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import SelectionList from "../../components/selectionList";
    import SearchSpielerResult from "./searchSpielerResult";
    import algoliasearch from "algoliasearch"
    import ErrorMsg from "../../components/elements/errorMsg";
    import SearchSpielerMissingDocs from "./searchSpielerMissingDocs";
    import SearchSpielerAbgelaufen from "./searchSpielerAbgelaufen";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: {
            SearchSpielerAbgelaufen,
            SearchSpielerMissingDocs,
            ErrorMsg,
            SearchSpielerResult,
            SelectionList},
        name: "search-spieler",
        computed: {
            bindsRealTimeList(){return this.$store.state.local.bindsRealtimeList },
            user(){ return this.$store.state.user },
            landesverbaende(){
                let liste = [];
                this.$store.state.local.landesverbaende.forEach( (landesverband) => {
                    if ( this.user.permissions['lv'+landesverband.id] || this.user.permissions.pass ) {
                        liste.push(landesverband);
                    }
                });
                return liste;
            },
            /*spielerSearchResult(){
                console.log ("-------- COMPUTED spielerSearchResult");
                return this.searchSelected.id === 2 ?
                    this.$store.state.realtime.spielerSearchResultSingle ?
                    [this.$store.state.realtime.spielerSearchResultSingle] : [] :
                    this.$store.state.realtime.spielerSearchResult;
            },*/
        // algolia search
            /*fields () {
                if (!this.model) return [];
                return Object.keys(this.model).map(key => {
                    return {
                        key,
                        value: this.model[key] || 'n/a',
                    }
                })
            },*/
            items () {
                let perfects = [];
                let others = [];
                this.entries.forEach( (entry) => {
                    const Description = entry.nachname + ' ' + entry.vorname  ;
                    if ( Description.toUpperCase().indexOf(this.search.toUpperCase()) !== -1 ) {
                        perfects.push(Object.assign({}, entry, { Description }))
                    } else {
                        others.push(Object.assign({}, entry, { Description }))
                    }
                });
                return perfects.sort((a, b) => a.Description > b.Description ? 1 : -1)
                    .concat( others.sort((a, b) => a.Description > b.Description ? 1 : -1) );
                /*return this.entries.map(entry => {
                    const Description = entry.vorname + ' ' + entry.nachname;
                    return Object.assign({}, entry, { Description })
                })*/
            },
        },
        data: () => ({
            singleSearch: [],
            searchTypes: [
                { id: 2, name: 'Vor-/Nachname', searchField: 'id', operator: null },
                //{ id: 0, name: 'Nachname', searchField: 'nachname' },
                { id: 1, name: 'Passnummer', searchField: 'search.passNumbers.', operator: '==' },
                { id: 3, name: 'Passablaufjahr', searchField: 'search.lastAktiv.', operator: '==' },
                { id: 4, name: 'fehlende Dokumente', searchField: 'search.docs', operator: 'in' },
            ],
            lvId: '',
            searchSelected: null,
            searchDB: '',
            searchJahr: '',
        // algolia search
            entries: [],
            model: null,
            search: null,
            searchCall: null,
            loading: false,
            errorMsg: '',
        }),
        created(){
            if ( this.landesverbaende.length > 0 ) { this.lvId = this.landesverbaende[0].id }
        },
        destroyed(){
            this.unbind();
        },
        methods: {
            unbind(){
                this.$store.dispatch('unbindRealtimeList', 'spielerSearchResult');
                this.$store.dispatch('unbindRealtimeList', 'spielerSearchResultSingle');
            },
            selectSearch(item){
                this.searchSelected = item;
                this.search = '';
                this.searchDB = '';
                this.unbind();
            },
            startSearch(){
                if ( this.searchSelected.id !== 2 ) {
                    this.firebaseSearch();
                } else {
                    this.algoliaSearch();
                }
                /*this.$store.dispatch('unbindRealtimeList', 'pendingActions');
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler_actions',
                    queryField: 'status_lvVerein_pending',
                    queryOperator: 'array-contains',
                    queryValue: this.landesverband.id + '' + this.verein.id,
                    storeField: 'pendingActions',
                });*/
            },
            async firebaseSearch(){
                if ( this.searchSelected.id === 3 && !this.verifyPassSearch() ) { return }
                const searchField = this.setSearchField();
                const searchValue = await this.setSearchValue();
                /*const searchValue = this.searchSelected.id === 0 ? this.searchDB.toUpperCase() :
                                    this.searchSelected.id === 1 ? true : this.model.objectID;*/
                console.log ("firebaseSearch", searchField, this.searchSelected.operator, searchValue);
                this.unbind();
                if ( this.searchSelected.id === 2 ) {
                    console.log ("------- bindRealtimeDocument: ", searchValue);
                    if ( searchValue.type === 'single' ) {
                        this.$store.dispatch('bindRealtimeDocument', {
                            collection: 'spieler',
                            docId: searchValue.value,
                            storeField: 'spielerSearchResultSingle',
                        });
                    } else {
                        this.$store.state.local.bindsRealtimeList = true;
                        this.$store.dispatch('bindRealtimeList', {
                            collection: 'spieler',
                            queryField: 'search.userUnique',
                            queryOperator: 'in',
                            queryValue: searchValue.value,
                            storeField: 'spielerSearchResultSingle',
                        });
                    }
                } else {
                    this.$store.state.local.bindsRealtimeList = true;
                    this.$store.dispatch('bindRealtimeList', {
                        collection: 'spieler',
                        queryField: searchField,
                        queryOperator: this.searchSelected.operator,
                        queryValue: searchValue,
                        storeField: 'spielerSearchResult',
                    });
                }
            },
                setSearchField(){
                    switch (this.searchSelected.id) {
                        case 1:  return this.searchSelected.searchField + this.searchDB;
                        case 3:  return this.searchSelected.searchField + this.lvId;
                        default: return this.searchSelected.searchField;
                    }
                },
                async setSearchValue(){
                    switch (this.searchSelected.id) {
                        case 0:  return this.searchDB.toUpperCase();
                        case 1:  return true;
                        case 2:  return await this.setSearchValueAlgolia();
                        case 3:  return this.searchJahr + '-06-30';
                        case 4:  return [this.lvId + '_0_1', this.lvId + '_1_0', this.lvId + '_1_1'];
                    }
                },
                    async setSearchValueAlgolia(){
                        let nrOfMatches = 0
                        this.entries.forEach( (entry) => {
                            if ( entry.nachname === this.model.nachname && entry.vorname === this.model.vorname ) nrOfMatches++
                        });
                        if ( nrOfMatches > 1 ) {
                            const spielerList = await FirebaseRead.readDocListDouble('spieler', [
                                {field: 'vorname', operator: '==', value: this.model.vorname },
                                {field: 'nachname', operator: '==', value: this.model.nachname },
                            ])
                            let spielerSearchKeys = []
                            spielerList.forEach( (spieler) => {
                                spielerSearchKeys.push(spieler.search.userUnique)
                            });
                            return {type: 'multiple', value: spielerSearchKeys}
                        } else {
                            return {type: 'single', value: this.model.objectID};
                        }
                    },
            algoliaSearch(){
                const client = algoliasearch(this.$store.state.config.algolia.app_id,
                                             this.$store.state.config.algolia.search_key);
                const index = client.initIndex(this.$store.state.config.algolia.index);
                return index
                    .search(this.search, {
                        hitsPerPage: 50
                    }) // this.searchDB
                    .then((responses)=> {
                        this.entries = responses.hits;
                        this.loading = false;
                    });
            },
            keyPressed(e, type){
                if ( e.keyCode === 13 ) {
                    this.startSearch();
                } else {
                    if ( type === 'pass' && e.target.value > 999999 ) {
                        this.searchDB = e.target.value.toString().substr(0,6);
                    } else if ( type === 'jahr' && e.target.value > 9999 ) {
                        this.searchJahr = e.target.value.toString().substr(0,4);
                    }
                }
            },
            verifyPassSearch(){
                const jahr = parseInt(this.searchJahr);
                if ( this.lvId && jahr!=='' && jahr > 2000 && jahr < 9999 ) {
                    return true;
                } else {
                    this.errorMsg = 'Bitte ein gültiges Jahr eingeben!';
                    return false;
                }
            }
        },
        watch: {
            search () {
                clearTimeout(this.searchCall);
                if ( this.search && this.search.length > 2 ) {
                    this.loading = true;
                    this.searchCall = setTimeout( () => {  this.algoliaSearch() }, 500);
                } else {
                    this.loading = false;
                    this.entries = [];
                }
            },
            searchJahr(){ this.errorMsg = ''},
            model(){
                console.log ("WATCH model", this.model);
                if ( this.model ) {
                    this.firebaseSearch();
                    setTimeout( () => { clearTimeout(this.searchCall); this.loading = false; }, 10); // to avoid reload after selection
                }
            },
            lvId(){
                if ( this.searchJahr || (this.searchSelected && this.searchSelected.id === 4) ) {
                    this.firebaseSearch()
                }
            }
        }
    }
</script>

<style scoped>
    .navDrawer { position: fixed; bottom: 0; border-right: solid 1px lightgrey; top: 48px; left: 0; width: 200px}
    .navDrawerMob { position: fixed; bottom: 0; border-right: solid 1px lightgrey;
        top: 48px; left: 0; right: 0; background-color: white; z-index: 1}
    .content { position: fixed; bottom: 0; top: 48px; right: 0;
        left: 200px; overflow-y: auto; background-color: #f2f2f2}
    .logo {     position: absolute;   -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%); opacity: 0.3;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);}

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>